import { Component, OnInit } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NaoEncontreiDialog } from '../nao-encontrei/nao-encontrei';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { Produtos } from '../../../../models/produtos.model';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-mostrar-produto-fornecedor',
  templateUrl: './mostrar-produto-fornecedor.component.html',
  styleUrls: ['./mostrar-produto-fornecedor.component.css']
})
export class MostrarProdutoFornecedorComponent implements OnInit {
  fn;
  limit = 30;
  pagina = 0;
  primeiro: string;
  ultimo: string;

  fornecedor:number;
  categoria:number;
  subCategoria:number;

  procurar: string = "";
  produtosPesquisa: Array<any> = [];
  produtos: Array<any> = [];
  produtoClass: Produtos;
  constructor(private dados: DadosService, private params: ActivatedRoute,
    private db: AngularFirestore,
    private router: Router,
    private dialog: MatDialog) {

    this.fn = this.getProdutosMais;
//    console.log(this.params.snapshot.params);

  }

  ngOnInit() {
    if (this.params.snapshot.params.codigo) {
//      console.log('getProdutoMais');
      this.fornecedor = Number(this.params.snapshot.params.codigo);
      this.fn = this.getProdutosMais;
    }
    if (this.params.snapshot.params.tipo){
 //     console.log('estouComSorte');
      this.fn = this.estouComSorte;
    }
    if (this.params.snapshot.params.categoria){
 //     console.log('categoria')
      this.categoria = this.params.snapshot.params.categoria;
      this.fn = this.getCategoria;
    }

    this.fn('asc');
  }

  verMais(typ) {
    this.fn(typ);
  }

  getOffset(k, typ): number {
    if (typ == 'asc') {
      this.pagina = this.pagina + 1;
      if (this.ultimo)
        k.startAfter(this.ultimo);
    }
    if (typ == 'desc') {
      this.pagina = this.pagina - 1;
      if (this.primeiro)
        k.endBefore(this.primeiro);
    }

    if (this.pagina < 0)
      this.pagina = 0;


    return (this.pagina * this.limit);

  }

  estouComSorte(typ){
    if (!this.produtoClass) {
      this.produtoClass = new Produtos(this.db,0,false);
    }
    this.produtoClass.snapshot(r => {
      var k = r.where("ativaPromocao", "==", true)
        .where("inativo", "==", false)
        .orderBy('scorePosition', 'desc')
        .limit(this.limit);
      this.getOffset(k, typ);
      return k;
    }, d => {
      this.produtos = d;
      if (d.length > 0) {
        this.ultimo = d[d.length - 1].scorePosition;
        this.primeiro = d[0].scorePosition;
       // console.log('pg', this.pagina);
      } else {
        this.pagina = 0;
      }
    }
    )

  }

  getCategoria(typ){
    if (!this.produtoClass) {
      this.produtoClass = new Produtos(this.db,0,false);
    }
    this.produtoClass.snapshot(r => {
      var k = r.where("categoria", "==", this.categoria)
        .where("inativo", "==", false)
        .orderBy('scorePosition', 'desc')
        .limit(this.limit);
      this.getOffset(k, typ);
      return k;
    }, d => {
      this.produtos = d;
      if (d.length > 0) {
        this.ultimo = d[d.length - 1].scorePosition;
        this.primeiro = d[0].scorePosition;
       // console.log('pg', this.pagina);
      } else {
        this.pagina = 0;
      }
    }
    )

  }


  getProdutosMais(typ) {
    if (!typ) typ = "asc";
    if (!this.produtoClass) {
      this.produtoClass = new Produtos(this.db,0,false);
    }
    this.produtoClass.snapshot(r => {
      var k = r.where("fornecedor", "==", this.fornecedor)
        .where("inativo", "==", false)
        .orderBy('scorePosition', 'desc')
        .limit(this.limit);
      this.getOffset(k, typ);
      return k;
    }, d => {
      this.produtos = d;
      if (d.length > 0) {
        this.ultimo = d[d.length - 1].scorePosition;
        this.primeiro = d[0].scorePosition;
      //  console.log('pg', this.pagina);
      } else {
        this.pagina = 0;
      }
    }
    )
  }


  getProdutos(fornecedor: number) {


    if (fornecedor == null) {
      this.dados.fornecedorCorrente = this.params.snapshot.params.codigo;
      fornecedor = this.dados.fornecedorCorrente;
    } else {
      this.dados.fornecedorCorrente = fornecedor;
    }
    

    this.getProdutosMais('nope');

  }



  procurarPor() {
    this.dados.getProcurarProdutoPor(
      this.procurar,
      d => {
        this.produtosPesquisa = d;
      });
  }

  naoEncontrei() {
    const dialogConfig = new MatDialogConfig();

    this.dados.regAnalytics(this.dados.fornecedorCorrente,'produtos','naoEncontrei',1);

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '450px';

    dialogConfig.data = {
      fornecedor: this.dados.fornecedorCorrente,
      title: 'Produto não encontrado',
    };

    this.dialog.open(NaoEncontreiDialog, dialogConfig);
  }

}
